module.exports = __webpack_public_path__ + "static/img/DSN-Logo.2d62db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DSN-Logo.png
// module id = wCQw
// module chunks = 0